import { IApplicationState } from '../../types/redux';

export const selectProject = (state: IApplicationState) => {
  return state.projectData.project;
};
